import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";

export default function LogMeetingButton() {

    const navigate = useNavigate();
    const isMobile = useIsMobile();
        
    return (
        <Box>
            {isMobile ? (
                <Button
                    variant="contained"
                    sx={{
                        bgcolor: "darkred",
                        '&:hover': {
                                bgcolor: 'red',
                            },
                        height:'94px', 
                        width: '40vw'
                    }}
                    onClick={() => navigate("/meetings/add")}
                >
                    Add Meeting
                </Button>
            ) : (
                <Button
                    variant="contained"
                    sx={(theme) => ({
                        bgcolor: theme.palette.primary.main,
                        '&:hover': {
                                bgcolor: theme.palette.primary.dark,
                            },
                        height:'64px', 
                        width: '192px'
                    })}
                    onClick={() => navigate("/meetings/add")}
                >
                    Add Meeting
                </Button>
            )}
        </Box>
        
    );
}